<template>
  <div>
    <div class="headline text-center mb-6">
      {{ $t('tuneMic') }}
    </div>
    <div class="my-6">
      <MicrophoneCheck @checked="microphoneChecked">
        <template #text>
          &laquo;{{ $t('helloMyNameIs') }}&raquo;
        </template>
      </MicrophoneCheck>
    </div>
  </div>
</template>

<script>
import MicrophoneCheck from '@huntica/huntica-interview-module/src/components/MicrophoneCheck.vue';

export default {
  name: 'InterviewMicrophoneCheck',
  components: {
    MicrophoneCheck,
  },
  props: {
    candidate: {
      type: Object,
      required: false,
    },
  },
  methods: {
    microphoneChecked(value) {
      if (value === true) {
        this.$emit('done');
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  tuneMic: Mic setup
  helloMyNameIs: Make sure the indicator reaches the green zone
</i18n>

<i18n locale="ru" lang="yaml">
  tuneMic: Настройте микрофон
  helloMyNameIs: Если индикатор находится в зелёной зоне, значит микрофон работает нормально.
</i18n>
